import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi everyone! I’m <span className="purple">Pavan V Anish</span>{" "}
            from <span className="purple">Kerala, India</span>.
            <br />
            I’m currently an<span className="purple"> Engineering </span>student at{" "}
            <br /><span className="purple">Amal Jyothi College of Engineering</span> {" "}
            doing UG in{" "}
            <br /><span className="purple">Computer Science</span> from{" "}
            <span className="purple">2024</span>. <span className="purple">to 2028</span>.
            <br />
            <br />
            Outside of coding, I love engaging in activities that keep me
            creative and inspired:
          </p>

          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Games 🎮
            </li>
            <li className="about-activity">
              <ImPointRight /> Watching Series/Movies ✍️
            </li>
            <li className="about-activity">
              <ImPointRight /> Traveling and Exploring New Places 🌍
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Strive to build things that make a difference!"{" "}
          </p>
          <footer className="blockquote-footer">PAVAN</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
